/**
 * Enums de incidencias
 * Enumeraciones relacionadas con incidencias
 */

export enum IncidenceMainType {
    DOCUMENTATION_INVENTORY = 'DOCUMENTATION_INVENTORY',
    PUNCTUALITY = 'PUNCTUALITY',
    WRONG_DELIVERY = 'WRONG_DELIVERY',
    FUEL = 'FUEL',
    ADDITIONAL_SERVICES = 'ADDITIONAL_SERVICES',
    EXCESS_KILOMETERS = 'EXCESS_KILOMETERS',
    BEHAVIOR_APPEARANCE = 'BEHAVIOR_APPEARANCE',
    DAMAGES = 'DAMAGES',
    FINE = 'FINE',
    //BILLING = 'BILLING',
    OPERATIONS_PROCESS = 'OPERATIONS_PROCESS',
    FRAUD = 'FRAUD',
    DRIVER_RECOGNITION = 'DRIVER_RECOGNITION',
    OTHER = 'OTHER'
}

export const incidencesMainTypeDescriptions: Record<IncidenceMainType, string> = {
    [IncidenceMainType.DOCUMENTATION_INVENTORY]: 'incidenceMainType.DOCUMENTATION_INVENTORY',
    [IncidenceMainType.PUNCTUALITY]: 'incidenceMainType.PUNCTUALITY',
    [IncidenceMainType.WRONG_DELIVERY]: 'incidenceMainType.WRONG_DELIVERY',
    [IncidenceMainType.FUEL]: 'incidenceMainType.FUEL',
    [IncidenceMainType.ADDITIONAL_SERVICES]: 'incidenceMainType.ADDITIONAL_SERVICES',
    [IncidenceMainType.EXCESS_KILOMETERS]: 'incidenceMainType.EXCESS_KILOMETERS',
    [IncidenceMainType.BEHAVIOR_APPEARANCE]: 'incidenceMainType.BEHAVIOR_APPEARANCE',
    [IncidenceMainType.DAMAGES]: 'incidenceMainType.DAMAGES',
    [IncidenceMainType.FINE]: 'incidenceMainType.FINE',
    //[IncidenceMainType.BILLING]: 'incidenceMainType.BILLING',
    [IncidenceMainType.OPERATIONS_PROCESS]: 'incidenceMainType.OPERATIONS_PROCESS',
    [IncidenceMainType.FRAUD]: 'incidenceMainType.FRAUD',
    [IncidenceMainType.DRIVER_RECOGNITION]: 'incidenceMainType.DRIVER_RECOGNITION',
    [IncidenceMainType.OTHER]: 'incidenceMainType.OTHER'
};


/**
 * IncidenceSubTypeEnum, * 
 * * `DOC_NOT_SENT` - Documentación no enviada
 * * `DOC_INCOMPLETE` - Documentación incompleta
 * * `DOC_INVALID` - Documento incorrecto o no válido
 * * `INVENTORY_INCOMPLETE` - Fotos o inventario incompleto
 * * `SIGNATURE_MISSING` - Firma/validación ausente
 * * `DOC_OTHER` - Otro problema de documentación
 * * `PUNCTUALITY_DELAY` - Retraso/adelanto (con horas)
 * * `WRONG_LOCATION` - Vehículo fuera del punto acordado
 * * `PUBLIC_ROAD` - Vehículo en vía pública
 * * `WRONG_PERSON` - No entregado a la persona correspondiente
 * * `UNAUTHORIZED_AREA` - Aparcado en zona no autorizada
 * * `DELIVERY_INSTRUCTIONS_IGNORED` - Instrucciones de entrega no seguidas
 * * `EXTRA_DISTANCE` - Distancia adicional (km)
 * * `WRONG_DELIVERY_OTHER` - Otro
 * * `FUEL_LOW_LEVEL` - Nivel inferior al esperado
 * * `FUEL_NO_DASH_PHOTO` - Foto del cuadro no aportada
 * * `FUEL_INCOHERENT` - Consumo incoherente con el trayecto
 * * `FUEL_OTHER` - Otro
 * * `WASH_NOT_DONE` - Lavado no realizado
 * * `CLEANING_INCOMPLETE` - Limpieza incompleta
 * * `BRIEFING_NOT_DONE` - Entrega explicada no realizada
 * * `SERVICE_NOT_PERFORMED` - Servicio no realizado según lo solicitado
 * * `ADDITIONAL_SERVICES_OTHER` - Otro
 * * `KM_EXCEEDED` - Km excedidos respecto a los previstos
 * * `BAD_DRESSING` - Vestimenta no adecuada
 * * `BAD_TREATMENT` - Trato incorrecto
 * * `UNPROFESSIONAL` - Falta de profesionalidad
 * * `INAPPROPRIATE_COMMENTS` - Comentarios inapropiados
 * * `BEHAVIOR_OTHER` - Otro
 * * `DAMAGE_EXTERNAL` - Daño exterior
 * * `DAMAGE_INTERNAL` - Daño interior
 * * `BROKEN_GLASS` - Rotura de luna
 * * `TIRE_PUNCTURE` - Pinchazo / llanta
 * * `WRONG_FUEL` - Error de combustible
 * * `MISUSE` - Uso indebido del vehículo
 * * `DAMAGE_OTHER` - Otro
 * * `FINE_PARKING` - Estacionamiento
 * * `FINE_SPEED` - Velocidad
 * * `FINE_TOLL` - Peaje o acceso restringido
 * * `FINE_OTHER` - Otra sanción
 * * `BILL_FAKE_RECEIPT` - Recibos falsos
 * * `BILL_OTHER` - Otro gasto o irregularidad
 * * `OP_NO_RESPONSE` - No respuesta en siniestro/avería/emergencia
 * * `OP_NO_COMMUNICATION` - No comunicación de incidencia
 * * `OP_UNREPORTED_CHANGES` - Modificación sin avisar
 * * `OP_MISSION_NOT_CLOSED` - Falta cierre de misión
 * * `OP_OTHER` - Otro
 * * `FRAUD_FAKE_JUSTIFICATION` - Justificante falso
 * * `FRAUD_FAKE_DOCUMENT` - Documentación falsificada
 * * `FRAUD_FAKE_BREAKDOWN` - Avería falsa/no existente
 * * `DRIVER_RECOGNITION` - Reconocimiento al conductor
 * * `OTHER_GENERAL` - Otro
 */
export enum IncidenceSubTypeEnum {
    ADDITIONAL_SERVICES_OTHER = "ADDITIONAL_SERVICES_OTHER",
    BAD_DRESSING = "BAD_DRESSING",
    BAD_TREATMENT = "BAD_TREATMENT",
    BEHAVIOR_OTHER = "BEHAVIOR_OTHER",
    BILL_FAKE_RECEIPT = "BILL_FAKE_RECEIPT",
    BILL_OTHER = "BILL_OTHER",
    BRIEFING_NOT_DONE = "BRIEFING_NOT_DONE",
    BROKEN_GLASS = "BROKEN_GLASS",
    CLEANING_INCOMPLETE = "CLEANING_INCOMPLETE",
    DAMAGE_EXTERNAL = "DAMAGE_EXTERNAL",
    DAMAGE_INTERNAL = "DAMAGE_INTERNAL",
    DAMAGE_OTHER = "DAMAGE_OTHER",
    DELIVERY_INSTRUCTIONS_IGNORED = "DELIVERY_INSTRUCTIONS_IGNORED",
    DOC_INCOMPLETE = "DOC_INCOMPLETE",
    DOC_INVALID = "DOC_INVALID",
    DOC_NOT_SENT = "DOC_NOT_SENT",
    DOC_OTHER = "DOC_OTHER",
    DRIVER_RECOGNITION = "DRIVER_RECOGNITION",
    EXTRA_DISTANCE = "EXTRA_DISTANCE",
    FINE_OTHER = "FINE_OTHER",
    FINE_PARKING = "FINE_PARKING",
    FINE_SPEED = "FINE_SPEED",
    FINE_TOLL = "FINE_TOLL",
    FRAUD_FAKE_BREAKDOWN = "FRAUD_FAKE_BREAKDOWN",
    FRAUD_FAKE_DOCUMENT = "FRAUD_FAKE_DOCUMENT",
    FRAUD_FAKE_JUSTIFICATION = "FRAUD_FAKE_JUSTIFICATION",
    FUEL_INCOHERENT = "FUEL_INCOHERENT",
    FUEL_LOW_LEVEL = "FUEL_LOW_LEVEL",
    FUEL_NO_DASH_PHOTO = "FUEL_NO_DASH_PHOTO",
    FUEL_OTHER = "FUEL_OTHER",
    INAPPROPRIATE_COMMENTS = "INAPPROPRIATE_COMMENTS",
    INVENTORY_INCOMPLETE = "INVENTORY_INCOMPLETE",
    KM_EXCEEDED = "KM_EXCEEDED",
    MISUSE = "MISUSE",
    OP_MISSION_NOT_CLOSED = "OP_MISSION_NOT_CLOSED",
    OP_NO_COMMUNICATION = "OP_NO_COMMUNICATION",
    OP_NO_RESPONSE = "OP_NO_RESPONSE",
    OP_OTHER = "OP_OTHER",
    OP_UNREPORTED_CHANGES = "OP_UNREPORTED_CHANGES",
    OTHER_GENERAL = "OTHER_GENERAL",
    PUBLIC_ROAD = "PUBLIC_ROAD",
    PUNCTUALITY_DELAY = "PUNCTUALITY_DELAY",
    SERVICE_NOT_PERFORMED = "SERVICE_NOT_PERFORMED",
    SIGNATURE_MISSING = "SIGNATURE_MISSING",
    TIRE_PUNCTURE = "TIRE_PUNCTURE",
    UNAUTHORIZED_AREA = "UNAUTHORIZED_AREA",
    UNPROFESSIONAL = "UNPROFESSIONAL",
    WASH_NOT_DONE = "WASH_NOT_DONE",
    WRONG_DELIVERY_OTHER = "WRONG_DELIVERY_OTHER",
    WRONG_FUEL = "WRONG_FUEL",
    WRONG_LOCATION = "WRONG_LOCATION",
    WRONG_PERSON = "WRONG_PERSON"
}

export const IncidenceSubTypeDescriptions: Record<IncidenceSubTypeEnum, string> = {
    [IncidenceSubTypeEnum.ADDITIONAL_SERVICES_OTHER]: 'incidenceSubType.ADDITIONAL_SERVICES_OTHER',
    [IncidenceSubTypeEnum.BAD_DRESSING]: 'incidenceSubType.BAD_DRESSING',
    [IncidenceSubTypeEnum.BAD_TREATMENT]: 'incidenceSubType.BAD_TREATMENT',
    [IncidenceSubTypeEnum.BEHAVIOR_OTHER]: 'incidenceSubType.BEHAVIOR_OTHER',
    [IncidenceSubTypeEnum.BILL_FAKE_RECEIPT]: 'incidenceSubType.BILL_FAKE_RECEIPT',
    [IncidenceSubTypeEnum.BILL_OTHER]: 'incidenceSubType.BILL_OTHER',
    [IncidenceSubTypeEnum.BRIEFING_NOT_DONE]: 'incidenceSubType.BRIEFING_NOT_DONE',
    [IncidenceSubTypeEnum.BROKEN_GLASS]: 'incidenceSubType.BROKEN_GLASS',
    [IncidenceSubTypeEnum.CLEANING_INCOMPLETE]: 'incidenceSubType.CLEANING_INCOMPLETE',
    [IncidenceSubTypeEnum.DAMAGE_EXTERNAL]: 'incidenceSubType.DAMAGE_EXTERNAL',
    [IncidenceSubTypeEnum.DAMAGE_INTERNAL]: 'incidenceSubType.DAMAGE_INTERNAL',
    [IncidenceSubTypeEnum.DAMAGE_OTHER]: 'incidenceSubType.DAMAGE_OTHER',
    [IncidenceSubTypeEnum.DELIVERY_INSTRUCTIONS_IGNORED]: 'incidenceSubType.DELIVERY_INSTRUCTIONS_IGNORED',
    [IncidenceSubTypeEnum.DOC_INCOMPLETE]: 'incidenceSubType.DOC_INCOMPLETE',
    [IncidenceSubTypeEnum.DOC_INVALID]: 'incidenceSubType.DOC_INVALID',
    [IncidenceSubTypeEnum.DOC_NOT_SENT]: 'incidenceSubType.DOC_NOT_SENT',
    [IncidenceSubTypeEnum.DOC_OTHER]: 'incidenceSubType.DOC_OTHER',
    [IncidenceSubTypeEnum.DRIVER_RECOGNITION]: 'incidenceSubType.DRIVER_RECOGNITION',
    [IncidenceSubTypeEnum.EXTRA_DISTANCE]: 'incidenceSubType.EXTRA_DISTANCE',
    [IncidenceSubTypeEnum.FINE_OTHER]: 'incidenceSubType.FINE_OTHER',
    [IncidenceSubTypeEnum.FINE_PARKING]: 'incidenceSubType.FINE_PARKING',
    [IncidenceSubTypeEnum.FINE_SPEED]: 'incidenceSubType.FINE_SPEED',
    [IncidenceSubTypeEnum.FINE_TOLL]: 'incidenceSubType.FINE_TOLL',
    [IncidenceSubTypeEnum.FRAUD_FAKE_BREAKDOWN]: 'incidenceSubType.FRAUD_FAKE_BREAKDOWN',
    [IncidenceSubTypeEnum.FRAUD_FAKE_DOCUMENT]: 'incidenceSubType.FRAUD_FAKE_DOCUMENT',
    [IncidenceSubTypeEnum.FRAUD_FAKE_JUSTIFICATION]: 'incidenceSubType.FRAUD_FAKE_JUSTIFICATION',
    [IncidenceSubTypeEnum.FUEL_INCOHERENT]: 'incidenceSubType.FUEL_INCOHERENT',
    [IncidenceSubTypeEnum.FUEL_LOW_LEVEL]: 'incidenceSubType.FUEL_LOW_LEVEL',
    [IncidenceSubTypeEnum.FUEL_NO_DASH_PHOTO]: 'incidenceSubType.FUEL_NO_DASH_PHOTO',
    [IncidenceSubTypeEnum.FUEL_OTHER]: 'incidenceSubType.FUEL_OTHER',
    [IncidenceSubTypeEnum.INAPPROPRIATE_COMMENTS]: 'incidenceSubType.INAPPROPRIATE_COMMENTS',
    [IncidenceSubTypeEnum.INVENTORY_INCOMPLETE]: 'incidenceSubType.INVENTORY_INCOMPLETE',
    [IncidenceSubTypeEnum.KM_EXCEEDED]: 'incidenceSubType.KM_EXCEEDED',
    [IncidenceSubTypeEnum.MISUSE]: 'incidenceSubType.MISUSE',
    [IncidenceSubTypeEnum.OP_MISSION_NOT_CLOSED]: 'incidenceSubType.OP_MISSION_NOT_CLOSED',
    [IncidenceSubTypeEnum.OP_NO_COMMUNICATION]: 'incidenceSubType.OP_NO_COMMUNICATION',
    [IncidenceSubTypeEnum.OP_NO_RESPONSE]: 'incidenceSubType.OP_NO_RESPONSE',
    [IncidenceSubTypeEnum.OP_OTHER]: 'incidenceSubType.OP_OTHER',
    [IncidenceSubTypeEnum.OP_UNREPORTED_CHANGES]: 'incidenceSubType.OP_UNREPORTED_CHANGES',
    [IncidenceSubTypeEnum.OTHER_GENERAL]: 'incidenceSubType.OTHER_GENERAL',
    [IncidenceSubTypeEnum.PUBLIC_ROAD]: 'incidenceSubType.PUBLIC_ROAD',
    [IncidenceSubTypeEnum.PUNCTUALITY_DELAY]: 'incidenceSubType.PUNCTUALITY_DELAY',
    [IncidenceSubTypeEnum.SERVICE_NOT_PERFORMED]: 'incidenceSubType.SERVICE_NOT_PERFORMED',
    [IncidenceSubTypeEnum.SIGNATURE_MISSING]: 'incidenceSubType.SIGNATURE_MISSING',
    [IncidenceSubTypeEnum.TIRE_PUNCTURE]: 'incidenceSubType.TIRE_PUNCTURE',
    [IncidenceSubTypeEnum.UNAUTHORIZED_AREA]: 'incidenceSubType.UNAUTHORIZED_AREA',
    [IncidenceSubTypeEnum.UNPROFESSIONAL]: 'incidenceSubType.UNPROFESSIONAL',
    [IncidenceSubTypeEnum.WASH_NOT_DONE]: 'incidenceSubType.WASH_NOT_DONE',
    [IncidenceSubTypeEnum.WRONG_DELIVERY_OTHER]: 'incidenceSubType.WRONG_DELIVERY_OTHER',
    [IncidenceSubTypeEnum.WRONG_FUEL]: 'incidenceSubType.WRONG_FUEL',
    [IncidenceSubTypeEnum.WRONG_LOCATION]: 'incidenceSubType.WRONG_LOCATION',
    [IncidenceSubTypeEnum.WRONG_PERSON]: 'incidenceSubType.WRONG_PERSON'
};

